import { useContext } from 'react';

import { FavoritesContext } from './provider';

export const useFavourite = () => {
  const ctx = useContext(FavoritesContext);
  if (!ctx) throw new Error('hook must be used within FavoritesProvider');
  return ctx;
};
